import React, { useEffect, useState } from "react";
import styles from "../../css/SmsDownloadReport.module.css";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import CustomAlert from "../../helpers/CustomAlert";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Loader from "../Loader/Loader";
import MasterTable from "../common/MasterTable";

const RcsDownloadReport = ({
  handleopenSmsDown,
  handleCloseRcsDown,
  onClose,
}) => {
  const { user } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);
  const [RCSDownloadData, setRcsDownloadData] = useState([]);
  const [noData, setNoData] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const rcsDownloadHeaders = [
    "Request ID",
    "Report Type",
    "Req Date & Time",
    "From Date",
    "To Date",
    "Status",
    "File",
  ];

  const rcsDownloadHeaderToKeyMap = {
    "Request ID": "id",
    "Report Type": "reportType",
    "Req Date & Time": "createdDate",
    "From Date": "reqFromDate",
    "To Date": "reqToDate",
    Status: "status",
    File: "downloadUrl",
  };

  useEffect(() => {
    downloadReport(1);
  }, []);

  const downloadReport = async (currentPage) => {
    setLoading(true);
    setNoData(false);

    try {
      const requestBody = {
        username: user?.data?.username,
      };

      const response = await axiosPostApi(
        `${apiList.RCS_DOWNLOAD_HISTORY}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (response && response.data) {
        if (response.data.status === true && response.data.respCode === "00") {
          const downloadHistory = Array.isArray(response.data.data)
            ? response.data.data
            : [];
          setPageDetails(response.data.pageDetails);
          setRcsDownloadData(downloadHistory);

          if (!downloadHistory || downloadHistory.length === 0) {
            setNoData(true);
          } else {
            setNoData(false);
          }
        } else {
          setRcsDownloadData([]);
          setNoData(true);

          CustomAlert({
            title: "Failed",
            text: response.data.message || "Failed to fetch data",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } else {
        setRcsDownloadData([]);
        setNoData(true);
      }
    } catch (error) {
      console.error("Error fetching download history:", error);
      setRcsDownloadData([]);
      setNoData(true);

      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const pageSizeCount = pageDetails?.pageSize || 0;
  const totalRecord = pageDetails?.totalRecords || 0;

  return (
    <Box component="form">
      <div className={styles.modalOverlay}>
        <div className={styles.modalBox}>
          {/* Header */}
          <div className={styles.modalHeader}>
            <h2 className={styles.modalTitle}> Download Report </h2>
            <button
              className={styles.closeButton}
              onClick={handleCloseRcsDown}
              aria-label="Close modal"
            >
              <HighlightOffIcon />
            </button>
          </div>

          {/* Content */}
          <div className={styles.DownModalContent}>
            {loading ? (
              <Loader />
            ) : (
              <MasterTable
                headers={rcsDownloadHeaders}
                data={RCSDownloadData}
                filterFields={["id"]}
                entityType="RCS Download Report"
                headerToKeyMap={rcsDownloadHeaderToKeyMap}
                loading={loading}
                pageDetails={pageDetails}
                noData={noData}
                currentPage={currentPage}
                pageSize={pageSizeCount}
                totalRecord={totalRecord}
                fetchNextData={downloadReport}
                setCurrentPage={setCurrentPage}
                hideAction="hideAction"
              />
            )}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default RcsDownloadReport;
